import React, { useEffect, useState } from 'react'
import { Button, Table, Typography, Space, Image, Flex, Row, Col, Form, Select } from 'antd'
import { protrackData } from '../../../Data';
import { ActionButton, AlertModal } from '../..';
import { useNavigate } from 'react-router-dom';
import { SearchInput } from '../../../components';
import { useDispatch, useSelector } from 'react-redux';
import { actionsApi, TableLoader } from '../../../shared';
import { apiCalls } from '../../../shared/Apis';

let timer;
const { Text } = Typography;
const { Option } = Select
const ProjectTrackTable = () => {

    const navigate = useNavigate()
    const [form] = Form.useForm();
    const [deleteitem,setDeleteItem] = useState(false)
    const [ deletionLoading, setDeletionLoading]= useState(false)
    const dispatch = useDispatch()
    const { projectData, loadingproject, filters, pagination } = useSelector(state => state?.ProjectTrackgetapi)

    useEffect(()=>{
        dispatch(actionsApi?.getProjectTrack({...filters, ...pagination, pageNo: 1}))
    },[])

    const call = (pageNo=1, pageSize=10)=> {
        dispatch(actionsApi?.getProjectTrack({...filters, pageNo, pageSize}))
    }

     function searchHandler(name, pageNo=1, pageSize=20) {
        dispatch(actionsApi?.getProjectTrack({ ...filters, name, pageNo, pageSize }))
    }

    function debounce(func, delay) {
        return function(...args) {
            clearTimeout(timer)
            timer = setTimeout(() => {
                func.apply(this, args)
            }, delay)
        };
    }
    const debouncedSearchHandler = debounce(searchHandler, 400)
    

    const onChange = (value, row) => {
        const newStatus = value === 'Pending' ? 1 : 
        value === 'On-going' ? 2 :
        value === 'Complete' ? 3 : value ;
        dispatch(actionsApi?.projecttrackstatusResponse({ id: row.id, status: newStatus }));
        dispatch(actionsApi?.updateProjecttrackStatus({ id: row.id, status: newStatus }));
    };

    const columns = [
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Professional Name</Text>,
            dataIndex: 'professionalName',
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Client Name</Text>,
            dataIndex: 'clientName'
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Budget Min</Text>,
            dataIndex: 'budgetMin'
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Budget Max</Text>,
            dataIndex: 'budgetMax'
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Status</Text>,
            dataIndex: 'status',
            render: (status) => {
                if (status === 1) {
                    return <Text className='pending fs-12 badge-cs'>Pending</Text>;
                } else if(status === 2){
                    return <Text className='inactive fs-12 badge-cs'>Ongoing</Text>;
                } else {
                    return <Text className='active fs-12 badge-cs'>Complete</Text>;
                }
            },
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Action</Text>,
            key: 'action',
            fixed: 'right',
            width: 200,
            render: (_, row) => (
                <Space>
                    <Select
                        onChange={(value) => onChange(value, row)}
                        className='fs-12'
                        defaultValue={
                            row?.status === 1 ? 'Pending' :
                            row?.status === 2 ? 'On-going' :
                            row?.status === 3 ? 'Complete' : ''
                        }
                        style={{width: 100}}
                    >
                        <Option value="Pending">Pending</Option>
                        <Option value="On-going">On-going</Option>
                        <Option value="Complete">Complete</Option>
                    </Select>
                    <ActionButton
                        title='View Item'
                        shape="circle"
                        icon={<Image src='/assets/icons/view.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {navigate(`/protrack/detail/${row?.id}`)}}
                    />
                    <ActionButton
                        title='Delete Item'
                        shape="circle"
                        icon={<Image src='/assets/icons/delete.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {setDeleteItem({name: row?.clientName, id: row?.id})}}
                    />
                </Space>
            ),
        },
    ];

    // delete job api
    const DeleteProjectTrack= async ()=>{
        setDeletionLoading(true)
        let result= await apiCalls?.ProjectTrackapi?.DeleteProjectTrack(deleteitem?.id)
        if(result){
            setDeleteItem(null)
            searchHandler('')
        }
        setDeletionLoading(false)
    }

    return (
        <>
        <Flex vertical gap={20}>
            <Form
                form={form}
                layout="vertical"
            >
                <Row gutter={[16,16]} align={'middle'}>
                    <Col lg={8} md={12} sm={24} xs={24}>
                        <SearchInput 
                            name='name'
                            placeholder='Search'
                            value={form.getFieldValue('name') || ''}
                            prefix={<img src='/assets/icons/search.png' width={20} />}
                            className='border-light-gray pad-x ps-0 radius-8 fs-13 search-w'
                            onChange={(e)=> debouncedSearchHandler(e.target.value, 1,20)}
                        />
                    </Col>
                </Row>
            </Form>
            <Table
                size='large'
                columns={columns}
                dataSource={projectData}
                className='pagination'
                showSorterTooltip={false}
                scroll={{ x: 1600 }}
                pagination={{
                    hideOnSinglePage: true,
                    total: pagination?.totalRecords,
                    pageSize: pagination?.pageSize,
                    defaultPageSize: pagination?.pageSize,
                    current: pagination?.pageNo,
                    size: "default",
                    pageSizeOptions: ['10', '20', '50', '100'],
                    onChange: (pageNo, pageSize) => call(pageNo, pageSize),
                    showTotal: (total) => <Button className='brand-bg border0 text-white'>Total: {total}</Button>,
                }}
                loading = {
                    {
                        ...TableLoader,
                        spinning: loadingproject
                    }
                }
            />
        </Flex>
        <AlertModal
            visible={deleteitem}
            deleteitem={deleteitem}
            callBack={DeleteProjectTrack}
            deletionLoading={deletionLoading}
            onClose={()=>{setDeleteItem(false)}}
        />
        </>
    )
}

export { ProjectTrackTable }